import {createApp} from 'vue'
import {createPinia} from 'pinia'
import './theme.css'
import './style.css'
import './pwa/ios/shell.css'
import './base-button.css'
import App from './App.vue'
import router from "./router.ts";
import {i18n} from "./localization/localization.ts";
import adapter from 'webrtc-adapter';
import {logger, LogLevel} from "./utils/logger.ts";
import {errorReporter} from "./sdk/utils/ErrorReporter";
import {vAudioSink} from "./directives/vAudioSink.ts";
import {logBackends} from "./utils/backends.ts";
// import * as Sentry from '@sentry/vue';

// Set app name and version from environment
const appName = (process.env.APP_NAME as string) || 'YourTeams';
const buildVersion = (process.env.BUILD_VERSION as string) || 'dev';
document.title = appName;

// Вывод версии в консоль
console.log(`%c ${appName} ${buildVersion} `, 'background: #2563eb; color: white; font-weight: bold; padding: 4px 8px; border-radius: 4px;');

// Force Safari to re-read theme-color after CSS loads
const forceThemeColorUpdate = () => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
        const color = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-bg').trim() || '#1e1e1e';
        meta.setAttribute('content', '#000000');
        requestAnimationFrame(() => {
            meta.setAttribute('content', color);
        });
    }
};
forceThemeColorUpdate();

// Configure logger level based on debug query parameter
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('debug') === 'true') {
    logger.setLevel(LogLevel.DEBUG);
}

logger.info('main', `App: ${appName}, Browser: ${adapter.browserDetails.browser}:${adapter.browserDetails.version}`)

// Разрешить список бэкендов при загрузке и вывести источник в консоль.
logBackends()

errorReporter.installGlobalHandlers()

const app = createApp(App)
const pinia = createPinia()

/*
Sentry.init({
    app,
    dsn: 'https://27249745a0b644628ebe9d997510d373@app.glitchtip.com/8557',
    integrations: [Sentry.browserTracingIntegration({router}), Sentry.replayIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        // "https://yourteams.org",
        // "https://stage.yourteams.org",
        // "https://b1.yourteams.org",
        // "https://b2.yourteams.org",
        // "https://b3.yourteams.org"
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});
*/
app.use(pinia)
app.use(router)
app.use(i18n)
app.directive('audio-sink', vAudioSink)
app.mount('#app')

